import { useTranslation } from 'react-i18next'
import { PrometheusAlert, RuuviTag, RuuviTagCondition } from '../types'
import RuuviTagStats from './RuuviTagStats'
import { AlertRuleName } from '../enums'
import { translateAlertRuleName } from '../utils/alert'

interface RuuviTagHumidityStatsProps {
  ruuviTag: RuuviTag
  ruuviTagCondition: RuuviTagCondition | null
  alerts?: PrometheusAlert[]
  loading?: boolean
}

export default function RuuviTagHumidityStats({
  ruuviTag,
  ruuviTagCondition,
  alerts = [],
  loading = false
}: RuuviTagHumidityStatsProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The humidity alerts.
   */
  const humidityAlerts = alerts.filter(
    (alert) =>
      alert.labels.alertname === AlertRuleName.LOW_HUMIDITY ||
      alert.labels.alertname === AlertRuleName.HIGH_HUMIDITY
  )

  /**
   * Indicates if there is an active humidity alert.
   */
  const isHumidityAlerting = humidityAlerts && humidityAlerts.length > 0

  /**
   * The latest humidity alert.
   */
  const latestHumidityAlert =
    humidityAlerts && humidityAlerts.length > 0 ? humidityAlerts[0] : undefined

  return (
    <RuuviTagStats
      ruuviTag={ruuviTag}
      title={t('humidity')}
      value={ruuviTagCondition?.humidityAvg}
      unit="%"
      date={ruuviTagCondition?.time}
      loading={loading}
      alerting={isHumidityAlerting}
      alertText={
        latestHumidityAlert && translateAlertRuleName(latestHumidityAlert.labels.alertname)
      }
    />
  )
}
